import styled from 'styled-components/macro';

export const FillSpace = styled.div`
  padding: 28.5px;

  @media screen and (max-width: 767px) {
    padding: 31px;
  }
`;

export const Item = styled.div`
  transition: all 0.25s ease-in-out;
  box-sizing: border-box;

  &:focus,
  & > div:focus {
    outline: none !important;
  }

  border: 1px solid rgba(0, 0, 0, 0.1);

  ${({ number, isOnDrag, parentType }) =>
    (((!isOnDrag || parentType == 'filter') && number == 1) || isOnDrag) &&
    `
    border-top-left-radius: 15px;
    border-top-right-radius: 15px;
  `}

  ${({ number, total, isOnDrag, parentType }) =>
    (((!isOnDrag || parentType == 'filter') && number == total) || isOnDrag) &&
    `
    border-bottom-left-radius: 15px;
    border-bottom-right-radius: 15px;
  `}



${({ isOnDrag }) =>
    isOnDrag &&
    `
    box-shadow: 0px 10px 18px rgba(0,0,0,0.25);
  `}

${({ isOnDrag, forType }) =>
    isOnDrag &&
    forType == 'List' &&
    `
    transform: scale(1.08, 1.04);
  `}

${({ isOnDrag, forType }) =>
    isOnDrag &&
    forType != 'List' &&
    `
    transform: scale(1.04, 1.020);
  `}

${({ forType, deletePrompt }) =>
    forType == 'List' &&
    !deletePrompt &&
    `
    &:active { transform: scale(0.97); }
    
  `}

${({ forType, isActive, color_l2, deletePrompt }) =>
    forType == 'List' &&
    !isActive &&
    !deletePrompt &&
    `
    &:hover { background: ${color_l2}!important; }
    
  `}



${({ isActive, color_l2 }) =>
    isActive &&
    `

    background: ${color_l2}!important;
  `}


${({ forType, isActive, deletePrompt }) =>
    forType == 'List' &&
    isActive &&
    deletePrompt &&
    `
    & { background: white!important; }
    
  `}
`;
